<div class="grid-stack-item-content" [ngClass]="{ isDraggable: draggable }">
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">
      {{ regionType === "geofences" ? "Geofences" : "Beacon Regions" }}
      {{ title }}
    </div>
    <div class="options">
      <button
        mat-icon-button
        class="option-button"
        [matMenuTriggerFor]="dataMenu"
      >
        <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
      </button>

      <mat-menu class="mat-menu-elaphant data-menu" #dataMenu="matMenu">
        <div class="column">
          <mat-radio-group
            class="mat-lightGreen"
            aria-label="Select an option"
            [(ngModel)]="regionType"
            (change)="onRegionTypeChange()"
          >
            <mat-radio-button value="geofences" class="mat-lightGreen"
              >Geofences</mat-radio-button
            >
            <mat-radio-button value="beacon_regions" class="mat-lightGreen"
              >Beacon Regions</mat-radio-button
            >
          </mat-radio-group>
        </div>
        <div class="column">
          <mat-radio-group
            class="mat-lightGreen"
            aria-label="Select an option"
            [(ngModel)]="valueType"
            (change)="onValueTypeChange()"
          >
            <mat-radio-button value="visits" class="mat-lightGreen"
              >Visits</mat-radio-button
            >
            <mat-radio-button value="avg_tos" class="mat-lightGreen"
              >Avg TOS</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </mat-menu>

      <button mat-icon-button>
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="grey"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content" lhpeElementLoader #elementLoader="elementloader">
    <ng-container>
      <table #geofencesTable mat-table [dataSource]="regionDataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="visits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Visits</th>
          <td mat-cell *matCellDef="let row">
            {{ row.visits ? row.visits : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="avg_tos">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Avg TOS</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.avg_tos">
              {{ row.avg_tos | sToHHMMSSPipe }}
            </ng-container>
            <ng-container *ngIf="!row.avg_tos"> - </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </ng-container>
  </div>
</div>
